import type { FragmentType } from '@packages/gql/generated/shopping';
import type { ScarcityFragmentFragmentDoc } from '@packages/gql/generated/shopping/ScarcityFragmentFragmentDoc';
import { useIntl } from 'react-intl';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import { unmask } from '@packages/gql/src/betterMasking';
import { Flag } from '@packages/shared/src/ui/Flag/Flag';

/* GraphQL */ `
  fragment ScarcityFragment on Availability {
    limitedStock
  }
`;

type ScarcityProps = {
  data: FragmentType<typeof ScarcityFragmentFragmentDoc>;
};

export const Scarcity = ({ data }: ScarcityProps) => {
  const { formatMessage } = useIntl();
  const {
    product: { hasScarcity },
  } = useConfig();

  const { limitedStock } = unmask<typeof ScarcityFragmentFragmentDoc>(data);

  return hasScarcity && limitedStock ? (
    <Flag
      text={formatMessage({
        id: 'scarcity.text',
        defaultMessage: 'Fast ausverkauft',
      })}
      variant="contrast"
      className="bg-color-scarcity"
    />
  ) : null;
};
